import { isNil } from 'lodash-es';

export const keepTwoNull = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(2);
  } else {
    return null;
  }
};
export const keepTwoOrLine = (data?: number) => {
  if (!isNil(data)) {
    return data.toFixed(2);
  } else {
    return '--';
  }
};
